import { useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useLocation, useHistory } from 'react-router-dom'
import SimpleSplitText from '@/components/SimpleSplitText'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const BreadcrumbNav = ({
  items,
  back,
}) => {
  const classes = useStyles()
  const location = useLocation()
  const currentSlug = useRef(location.pathname.split('/').filter((slug) => slug !== ''))
  const history = useHistory()
  const strings = useSelector((state) => state.language.string)

  return (
    <div className={classNames({
      [classes.root]: true,
      [classes.noItems]: !items,
    })}
    >
      {back && (
        <div className={classes.back}>
          <button
            onClick={() => history.goBack()}
          >
            <svg><use xlinkHref="#ico-arrow-left" /></svg>
            <SimpleSplitText
              text={strings.back_label}
              animation="linear"
            />
          </button>
        </div>
      )}
      {items && items.length > 0 && (
        <nav className={classes.nav}>
          <ul>
            {items.map((item) => (
              <li
                key={item.id}
                className={classNames({
                  [classes.disable]: currentSlug.current[currentSlug.current.length - 1] === item.slug,
                })}
              >
                <DelayLink
                  to={item.link}
                  className={classes.item}
                >
                  <SimpleSplitText
                    text={item.title}
                    animation="linear"
                  />
                </DelayLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  )
}

BreadcrumbNav.defaultProps = {
  back: false,
  items: false,
}

export default BreadcrumbNav
